<div class="card card-hover card-select"
     [ngClass]="{'selected-card': isSelected, 'loading-card': loading}"
     (click)="onCardClick()">

  <!-- Info icon -->
  <div class="info-icon" *ngIf="!loading && showTooltip">
    <img class="info"
         [src]="'/assets/images/info.png'"
         alt="info"
         [tooltip]="tooltip"
         [placement]="placement"
         [container]="container"
         [containerClass]="containerClass"
         [adaptivePosition]="adaptivePosition">
  </div>

  <!-- 🔹 When loading -->
  <ng-container *ngIf="loading; else cardContent">
    <div class="card-item d-flex align-items-center">
      <span>
        <ngx-skeleton-loader [theme]="{ 'width': '40px', 'height': '40px', 'border-radius': '50%' }"></ngx-skeleton-loader>
      </span>
      <div class="item-card-val ml-2">
        <ngx-skeleton-loader [theme]="{ 'width': '80px', 'height': '12px', 'margin-bottom': '6px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ 'width': '60px', 'height': '14px' }"></ngx-skeleton-loader>
      </div>
      <div class="card-label ml-auto">
        <ngx-skeleton-loader [theme]="{ 'width': '45px', 'height': '14px', 'border-radius': '6px' }"></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>

  <!-- 🔹 Actual content -->
  <ng-template #cardContent>
    <div class="card-item d-flex align-items-center">
      <span><img class="mr-3 ml-2 card-i-img" [src]="icon" alt="" width="47px"></span>
      <div class="item-card-val">
        <span>{{ title }}</span>
        <p>{{ value }}</p>
      </div>
      <div class="card-label" *ngIf="percentage !== undefined">{{ percentage }}<span *ngIf="showPercent">%</span></div>
    </div>
  </ng-template>

</div>
